import React from "react";
import { Modal, Button } from "react-bootstrap";
import { getPaymentMethod } from "./utils";

const VerifyPaymentModal = ({
  show,
  onHide,
  selectedSessionForVerify,
  handleConfirmVerify,
  paymentDataBySession,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Verify Payment / Insurance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ textAlign: "left" }}>Are you sure you want to manually verify the payment/insurance for this session?</p>
        {selectedSessionForVerify && (
          <div style={{ backgroundColor: "#F8FAFC", padding: "12px", borderRadius: "8px", marginTop: "12px" }}>
            <p style={{ margin: "4px 0", textAlign: "left" }}>
              <strong>Session ID:</strong> {selectedSessionForVerify.appointment_id || selectedSessionForVerify._id}
            </p>
            <p style={{ margin: "4px 0", textAlign: "left" }}>
              <strong>Client:</strong> {selectedSessionForVerify?.user?.firstname} {selectedSessionForVerify?.user?.lastname}
            </p>
            <p style={{ margin: "4px 0", textAlign: "left" }}>
              <strong>Payment Method:</strong> {getPaymentMethod(selectedSessionForVerify, paymentDataBySession)}
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirmVerify}>
          Verify
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VerifyPaymentModal;

